import {VStack, Image, Spacer, useColorModeValue, Box, Flex, IconButton, Heading, Button,Modal, ModalBody, ModalOverlay, ModalContent,Spinner,useDisclosure} from "@chakra-ui/react";
import { useState, useEffect } from 'react';

function LoadingPage(props) {
    useEffect(() => {
        const timer = setTimeout(() => {
            props.onLoadingClose();
            console.log("onclose")
        }, 5000);
        
      }, [props.isLoading]);
	return (
        <>

            <Modal isOpen={props.isLoading} size='full' onClose={props.onLoadingClose}>
            <ModalOverlay/>
            <ModalContent backgroundColor={'rgba(255, 255, 255, 0)'}>
            <ModalBody display='flex' alignItems='center' justifyContent={'center'}>
            <Spinner 
                size='xl' 
                emptyColor='gray.100'
                color='red.500'/>
            </ModalBody>
            
            </ModalContent>
            </Modal>
        </>
	);
}

export default LoadingPage;